import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    cancelOrderApprovalFn,
    postReviewApprovalFn,
    ReviewOrderApprovalParams,
} from "@tKgpco/Services/OrderApprovalService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<ReviewOrderApprovalParams, any>;

export const RequestOrderApprovalNotes: HandlerType = async props => {
    try {
        const result = props.parameter.cancelOrder
            ? await cancelOrderApprovalFn(props.parameter)
            : await postReviewApprovalFn(props.parameter);
        props.parameter?.onSuccess?.(result);
    } catch (error) {
        props.parameter?.onError?.("An error occurred while processing the approval.");

        return false;
    }
    localStorage.removeItem("approverNotes");
};

export const chain = [RequestOrderApprovalNotes];
const updateOrderApprovalStatus = createHandlerChainRunner(chain, "updateOrderApprovalStatus");
export default updateOrderApprovalStatus;
